import { Box, Collapse, FormControl, InputBase, InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Divider, Switch } from 'evee-ui-common/components/base';
import { formatTripDate } from 'evee-ui-common/utils';
import SearchDateInput from 'widgets/search/SearchDateInput';
import SearchLocationInput from 'widgets/search/SearchLocationInput';

import styles from './styles';

const MobileSearchInputs = ({
  tripDates,
  location,
  classes,
  onLocationChange,
  onLocationClick,
  onFlexibleDatesChange,
  onPickUpClick,
  onDropOffClick,
}) => {
  const tripStart = formatTripDate(tripDates.from);
  const tripEnd = formatTripDate(tripDates.to);
  const locationName = location?.name || '';

  return (
    <Box display="flex" flexDirection="column">
      <Box className={classes.root}>
        {onLocationClick ? (
          <FormControl className={classes.input}>
            <InputLabel shrink style={{ fontWeight: 500 }}>
              Location
            </InputLabel>
            <InputBase
              readOnly
              value={locationName}
              inputProps={{ placeholder: 'City, airport or suburb', style: { padding: '4px 0 0 0' } }}
              onClick={onLocationClick}
            />
          </FormControl>
        ) : (
          <SearchLocationInput
            multiline
            value={location}
            placeholder="City, airport or suburb"
            className={classes.input}
            classes={{ paper: classes.paper }}
            onChange={onLocationChange}
          />
        )}
      </Box>

      <Collapse in={!tripDates.flexible}>
        <Box className={classes.root}>
          <SearchDateInput
            value={tripStart}
            label="Start date"
            className={classes.input}
            InputProps={{
              placeholder: 'Add dates',
            }}
            onClick={onPickUpClick}
          />

          <Divider className={classes.divider} orientation="vertical" />

          <SearchDateInput
            value={tripEnd}
            label="End date"
            className={classes.input}
            InputProps={{
              placeholder: 'Add dates',
            }}
            onClick={onDropOffClick}
          />
        </Box>
      </Collapse>

      <Switch
        label="I'm flexible"
        variant="subtitle1"
        checked={tripDates.flexible}
        onChange={onFlexibleDatesChange}
      />
    </Box>
  );
};

MobileSearchInputs.propTypes = {
  tripDates: PropTypes.object,
  location: PropTypes.object,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    input: PropTypes.string.isRequired,
    divider: PropTypes.string.isRequired,
    paper: PropTypes.string.isRequired,
  }).isRequired,
  onLocationChange: PropTypes.func,
  onLocationClick: PropTypes.func,
  onFlexibleDatesChange: PropTypes.func,
  onPickUpClick: PropTypes.func,
  onDropOffClick: PropTypes.func,
};

MobileSearchInputs.defaultProps = {
  tripDates: {},
  location: {},
  onLocationChange: () => {},
  onLocationClick: null,
  onFlexibleDatesChange: () => {},
  onPickUpClick: () => {},
  onDropOffClick: () => {},
};

export default withStyles(styles)(MobileSearchInputs);
